// src/helper/getObjInfo.js

/*
 * Повертає сам об'єкт `obj`, якщо це непорожній об'єкт; інакше — false.
 * @param {*} obj - Значення поля obj (false|0|null|undefined|Object)
 * @returns {Object|false}
 */
export default function getObjInfo(obj) {
	if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false;
	return Object.keys(obj).length ? obj : false;
}
